module.exports = __webpack_public_path__ + "media/country_flags/pk-88d31355.png";